<template>
  <div class="media-column" style="position: relative;">
    <div class="media-background" :style="midiaBgStyle" />
    <div style="z-index: 2; display: flex; justify-content: center; padding-top: 25px;">
      <p class="title-text">{{ headerText }}</p>
    </div>
    <div class="media-wrapper">
      <img v-if="midiaType === 'image'" :src="midiaUrl" class="image" :style="mediaStyle" style="position: relative;" />
      <video v-else :src="midiaUrl" class="video" autoplay :style="mediaStyle" style="position: relative;" />
    </div>
    <div class="text-column">
      <div class="description-background" :style="descriptionContainerBgStyle"/>
      <div class="description-container" ref="textContainer">
        <p class="description-text" :style="{ lineHeight: lineHeight, fontSize: fontSize }">{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const midiaBg = require("../../../assets/tarjas/panela-sportv/midia-horizontal-container.png");
const descriptionContainerBg = require("../../../assets/tarjas/panela-sportv/midia-texto-descricao.png");

export default {
  props: {
    headerText: String,
    midiaType: String,
    midiaUrl: String,
    midiaSize: Object,
    text: String,
    lineHeight: Number,
    fontSize: Number
  },
  data() {
    return {
      textHeight: 0
    };
  },
  mounted() {
    this.updateTextHeight();
    this.$watch('text', this.updateTextHeight);
    window.addEventListener('resize', this.updateTextHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTextHeight);
  },
  methods: {
    updateTextHeight() {
      this.$nextTick(() => {
        if (this.$refs.textContainer) {
          this.textHeight = this.$refs.textContainer.offsetHeight + 30;
        }
      });
    }
  },
  computed: {
    mediaStyle() {
      // Verifica se a mídia tem a mesma altura e largura
      if (this.midiaSize && this.midiaSize.width / this.midiaSize.height < (16/9)) {
        return { height: '100% !important' };
      }
      return {};
    },
    midiaBgStyle() {
      const backgroundStyle = `background-image: url(${midiaBg}); background-repeat: round; background-size: cover;`;
      return `${backgroundStyle};`;
    },
    descriptionContainerBgStyle() {
      const height = this.textHeight > 0 ? this.textHeight : 240;
      const backgroundStyle = `background-image: url(${descriptionContainerBg}); background-repeat: no-repeat; background-size: 100% 100%; height: ${height}px;`;
      return backgroundStyle;
    },
  },
};
</script>

<style scoped lang="scss">
.media-column {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 595px;
  margin: 0 auto;
  overflow: visible; /* Alterado para permitir que o background seja visível */
}

.media-wrapper{
  display: flex;
  align-items: center;
  width: 595px;
  height: 330px;
  position: relative;
  z-index: 2;
}

.image,
.video {
  position: relative;
  width: 100%;
  z-index: 2;
  border: 6px solid #bff65c;
  border-radius: 6px;
}

.title-text {
  font-size: 3rem;
  line-height: 2.5rem;
  color: white;
  z-index: 2;
  font-family: "Galeana-Condensed-Black", sans-serif;
}

.media-background{
  position: absolute; 
  z-index: 0;
  left: -80px;
  top: -60px;
  width: 750px;
  height: 580px;
  pointer-events: none; /* Impede que o background interfira com interações */
}

.text-column {
  position: relative;
  z-index: 1;
}

.description-container {
  position: relative;
  width: 100%;
  padding-block: 15px;
  padding-inline: 20px;
  z-index: 2;
}

.description-text {
  font-family: "Galeana-Condensed-Regular", sans-serif;
  font-weight: 600;
  color: rgb(1, 83, 121);
  margin: 0;
}

.description-background{
  position: absolute; 
  z-index: -1;
  width: 650px;
  left: -30px;
  top: -20px;
  transition: height 0.3s ease;
  max-height: 300px;
  pointer-events: none; /* Impede que o background interfira com interações */
}
</style>
